<template>
  <div class="check-list-person auto-list_col_centered">
    <div>
      <p>{{ shortFio(responseDriverFio) }}</p>
      <el-rate
        v-if="!isMobile"
        :value="rateUser"
        disabled
        :colors="rateColor"
      />
      <taxation-status :status="status" />
    </div>
  </div>
</template>

<script>
import TaxationStatus from '@/components/Shared/TaxationStatus'
export default {
  name: 'ShortFIO',
  components: { TaxationStatus },
  props: {
    responseDriverFio: {
      type: String,
      default: '',
    },
    rateColor: {
      type: Array,
      default: () => ['#3498DB', '#3498DB', '#3498DB'],
    },
    rateUser: {
      type: Number,
      default: 3,
    },
    status: {
      type: String,
      default: 'not_stated',
    },
  },
}
</script>

<style scoped></style>
